<template>
  <v-layout column class="inner-pages">
    <Header />
    <SettingsBody />
  </v-layout>

</template>

<script>
  import SettingsBody from './SettingsBody'
  import Header from '../../layouts/Header'
  export default {
    components: {Header, SettingsBody},
    created () {
      setTimeout(() => {
        this.$store.commit('setIsCompactHeader', false)
      }, 100)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/views/auth/Settings.vue